import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '❄️',
      title: 'Aire Acondicionado',
      description: 'Todas nuestras habitaciones cuentan con aire acondicionado para tu máximo confort.'
    },
    {
      id: 2,
      icon: '💧',
      title: 'Agua Caliente',
      description: 'Disfruta de agua caliente las 24 horas en todas nuestras instalaciones.'
    },
    {
      id: 3,
      icon: '🍳',
      title: 'Cocina Equipada',
      description: 'Cocina completamente equipada disponible para todos nuestros huéspedes.'
    },
    {
      id: 4,
      icon: '🚗',
      title: 'Servicio de Uber',
      description: 'Servicio exclusivo de Uber para nuestros huéspedes al aeropuerto, volcán y tours.'
    },
    {
      id: 5,
      icon: '🧹',
      title: 'Limpieza Diaria',
      description: 'Mantenemos espacios impecables con servicio de limpieza todos los días.'
    },
    {
      id: 6,
      icon: '📶',
      title: 'WiFi Gratuito',
      description: 'Internet de alta velocidad disponible en todas las áreas del hostal.'
    },
    {
      id: 7,
      icon: '🔒',
      title: 'Lockers Seguros',
      description: 'Guarda tus pertenencias de forma segura en nuestros lockers individuales.'
    },
    {
      id: 8,
      icon: '🎯',
      title: 'Áreas Comunes',
      description: 'Espacios diseñados para la convivencia y el intercambio cultural.'
    }
  ];

  return (
    <section id="servicios" className="services">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">Servicios y Amenidades</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Todo lo que necesitas para una estadía inolvidable
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>

        <div className="services-highlight">
          <div className="highlight-box">
            <div className="highlight-icon">⭐</div>
            <h3>Servicio de Transporte Exclusivo</h3>
            <p>
              Ofrecemos servicio de Uber exclusivo para nuestros huéspedes. Te llevamos
              al aeropuerto, al imponente Volcán de Santa Ana, y a todos los tours que
              organizamos. ¡Viaja con comodidad y seguridad!
            </p>
            <div className="transport-destinations">
              <div className="destination-item">
                <span>✈️</span>
                <p>Aeropuerto</p>
              </div>
              <div className="destination-item">
                <span>🌋</span>
                <p>Volcán de Santa Ana</p>
              </div>
              <div className="destination-item">
                <span>🗺️</span>
                <p>Tours Locales</p>
              </div>
            </div>
          </div>
        </div>

        <div className="services-note">
          <p>
            <strong>Nota:</strong> En KAWILA nos esforzamos por brindarte la mejor experiencia.
            Si necesitas algún servicio adicional, no dudes en consultarnos. Estamos aquí
            para hacer de tu estadía algo memorable.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
